export default __webpack_public_path__ + "static/media/youtube_logo_white.85836f38.svg";